var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningEncrypt = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0015 8.36035V12.861",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1695 18.931L17.7745 18.0985C17.5315 17.9545 17.3335 17.608 17.3335 17.3245V15.4795M18.5656 13.1271L13.9177 4.75934C12.3154 1.86993 9.68707 1.86993 8.08485 4.75934L5.43847 9.51201L2.63008 14.5707C1.11786 17.2981 2.42305 19.5304 5.54649 19.5304H11.0013V19.5394H13.4881M18.5656 13.1271C18.2239 13.044 17.8671 13 17.5 13C15.016 13 13 15.016 13 17.5C13 18.234 13.176 18.9271 13.4881 19.5394M18.5656 13.1271C20.5358 13.606 22 15.3831 22 17.5C22 19.984 19.984 22 17.5 22C15.75 22 14.2323 20.9994 13.4881 19.5394",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9956 15.561H11.0037",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningEncrypt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning-encrypt.925708989719aabb37507f818e6e10b4.svg";